export default __webpack_public_path__ + "static/media/credit-cards.908b59b3.png";